import { useState, useEffect } from "react";
import { getCompetitionsImagesRetrieveQueryOptions } from "@/api/generated/backendAPI";
import { FaImage } from "react-icons/fa6";
import { useQuery  } from "@tanstack/react-query";

type Props = React.ImgHTMLAttributes<HTMLImageElement> & {
  licenseId: string;
  imageType: "main" | "sub";
  showNoImage: boolean;
};

function CompetitionImage(props: Props) {
  const { licenseId, imageType, showNoImage, ...imageProps } = props;
  const {data, isLoading, error} = useQuery(getCompetitionsImagesRetrieveQueryOptions(licenseId, imageType, {query: {retry: false, throwOnError: false}}))
  const [imageURL, setImageURL] = useState("");

  useEffect(() => {
    if(!isLoading){
      if(!imageURL && !error && data){
        const objURL = URL.createObjectURL(data);
        setImageURL(objURL)
      }
    }
  //eslint-disable-next-line
  }, [isLoading]);
  useEffect(() => {
    return () => {
      if(imageURL){
        URL.revokeObjectURL(imageURL)
      }
    }
  })

  const imagePropsObject = {
    ...imageProps,
    src: imageURL,
  };

  return (
    <>
      {!isLoading && imageURL ? (
        <img {...imagePropsObject} />
      ) : (
        showNoImage && (
          <div className={imagePropsObject.className}>
            <FaImage size={imageProps.width} />
          </div>
        )
      )}
    </>
  );
}

export default CompetitionImage;
